/* eslint-disable jsx-a11y/media-has-caption */

import {
  LaunchStatusEvent,
  LaunchStatusType,
  StreamerStatus,
} from "@pureweb/platform-sdk";

import "./styles.css";

import React from "react";

interface LoadingProps {
  LaunchRequestStatus: LaunchStatusEvent;
  StreamerStatus: StreamerStatus;
}

const LoadingView: React.FC<LoadingProps> = (props: LoadingProps) => {
  if (
    props.StreamerStatus === StreamerStatus.Connected ||
    props.StreamerStatus === StreamerStatus.Completed
  ) {
    return <div />;
  }

  let content;

  if (props.StreamerStatus === StreamerStatus.NotSupported) {
    content = (
      <div>
        <h3>
          Your browser does not support the necessary WebRTC capabilities.
        </h3>
      </div>
    );
  }
  if (
    props.LaunchRequestStatus.status === LaunchStatusType.Unavailable ||
    props.LaunchRequestStatus.status === LaunchStatusType.Error ||
    props.StreamerStatus === StreamerStatus.Failed
  ) {
    content = (
      <div>
        <h3>The experience is presently unavailable.</h3>
        <h3>Please refresh to request a new session.</h3>
      </div>
    );
  } else {
    return (
      <>
        <div className="video-loading-div">
          <div className="loading-div">
            {/* <div style={{ textAlign: "center" }}>
              <h3 className="loading-h3">Loading...</h3>
            </div> */}
          </div>
          <video
            className="loading-video"
            controls
            autoPlay
            loop
            playsInline
            style={{ pointerEvents: "none" }}
          >
            <source src="./junglePr.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </>
    );
  }
  return (
    <div className="loading-div">
      <div style={{ textAlign: "center" }}>{content}</div>
    </div>
  );
};

export default LoadingView;
